import api from "@/api/api";
import utils from "@/utils/index";
import { Toast } from "vant";

export default {
  methods: {
    /**
     * @method handleSubscriptionPaymentCase
     * @param {String} status
     * @description 处理apple-pay和google-pay支付方式
     */
    handleSubscriptionPaymentCase(caseNumber, res) {
      // caseNumber从路由获取
      // const caseNumber = utils.getUrlSearch("caseNumber");
      this.airwallexResponseData = JSON.parse(res.data.data.subscriptionData);
      this.paymentIntent = this.airwallexResponseData.paymentIntent;
      this.countryCode = this.airwallexResponseData.countryCode || "";
      if (caseNumber == 64) {
        // console.log("handlePaymentCase 64 - Airwallex card payment");
        // 对于Airwallex卡支付，先准备数据，等脚本加载完成后再显示弹窗
        // 先加载脚本，等加载完成后再显示弹窗
        this.loadSubscriptionAirwallexScript(() => {
          // 脚本加载完成后再显示弹窗，确保组件能正确初始化
          this.airwallexPopupShow = true;
        });
        // this.querySubscriptionOrder();
        return;
      }

      // 其他支付方式的处理逻辑
      // const data = JSON.parse(res.data.data.url);
      // this.loading = true;
      // this.clientSecret = JSON.parse(data.paymentIntent).client_secret;
      // this.countryCode = data.countryCode;
      // this.payTradeNo = res.data.data.payTradeNo;

      if (caseNumber == 65) {
        // Google Pay: 先显示弹窗，然后使用nextTick确保DOM更新后再创建按钮
        this.googleOApplePayShow = true;
        this.$nextTick(() => {
          console.log("Google Pay: DOM updated, loading Airwallex script...");
          this.loadAirwallexScript(() => {
            // 增加额外的延时确保弹窗完全渲染
            setTimeout(() => {
              this.createGooglePayButton(this.clientSecret);
            }, 200);
          });
        });
      }
      if (caseNumber == 66) {
        //     // Apple Pay: 先显示弹窗，然后使用nextTick确保DOM更新后再创建按钮
        this.googleOApplePayShow = true;
        this.$nextTick(() => {
          console.log("Apple Pay: DOM updated, loading Airwallex script...");
          this.loadAirwallexScript(() => {
            // 增加额外的延时确保弹窗完全渲染
            setTimeout(() => {
              this.createApplePayButton(this.clientSecret);
            }, 200);
          });
        });
      }
      // this.querySubscriptionOrder();
    },
    loadSubscriptionAirwallexScript(callback) {
      console.log(
        "loadAirwallexScript called, window.Airwallex exists:",
        !!window.Airwallex
      );
      if (window.Airwallex) {
        this.initializeSubscriptionAirwallex();
        if (callback) callback();
        return;
      }
      console.log("Loading Airwallex script...");
      this.loadScript(
        "https://checkout.airwallex.com/assets/elements.bundle.min.js",
        () => {
          this.initializeSubscriptionAirwallex();
          if (callback) callback();
        }
      );
    },
    initializeSubscriptionAirwallex() {
      if (typeof Airwallex !== "undefined") {
        // Initialize Airwallex
        // 判断当前环境
        const airwallexEnv =
          this.goodInfo.airwallexEnv === "LIVE" ? "prod" : "demo";
        const clientId =
          this.airwallexResponseData.client_id || "ZDgCslmDScaxsoZfTF9G9w";
        window.Airwallex.init({
          env: airwallexEnv, // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
          origin: window.location.origin, // Setup your event target to receive the browser events message
          clientId: clientId,
          locale: ""
        });
        this.loading = false;
      } else {
        console.error("Airwallex is not available.");
      }
    },

    /**
     * @method createApplePayButton
     * @description apple支付
     */
    createApplePayButton() {
      const client_secret = this.paymentIntent.client_secret || "";
      const intent_id = this.paymentIntent.id || "";
      const customer_id = this.paymentIntent.customer_id || "";
      const countryCode = this.countryCode || "";
      const _this = this;

      // 创建DOM检查和重试机制
      const checkDOMAndCreateButton = (retryCount = 0) => {
        const maxRetries = 10; // 最多重试10次
        const retryDelay = 100; // 每次重试间隔100ms

        console.log(`Apple Pay: Attempt ${retryCount + 1} to find DOM element`);

        // 检查 DOM 元素是否存在
        const targetElement = document.getElementById("googleOrApplePayButton");
        if (!targetElement) {
          if (retryCount < maxRetries) {
            console.log(
              `Apple Pay: Target element not found, retrying in ${retryDelay}ms...`
            );
            setTimeout(() => {
              checkDOMAndCreateButton(retryCount + 1);
            }, retryDelay);
            return;
          } else {
            console.error(
              "Apple Pay: Target element 'googleOrApplePayButton' not found after maximum retries"
            );
            _this.loading = false;
            return;
          }
        }

        console.log(
          "Apple Pay: Target element found, creating Apple Pay button"
        );

        try {
          const element = window.Airwallex.createElement("applePayButton", {
            countryCode: countryCode,
            // totalPriceLabel: "Think Academy",
            mode: "recurring",
            client_secret: client_secret,
            intent_id: intent_id,
            customer_id: customer_id,
            // 屏蔽银联:卡网络白名单不含 chinaUnionPay(验证 recurring 模式下是否生效)
            supportedNetworks: ["visa", "masterCard", "amex", "discover","jcb","maestro"]
          });

          element.mount("googleOrApplePayButton");

          // element挂载完成
          element.on("ready", async () => {
            this.loading = false;
          });
          element.on("success", async event => {
            // 打日志
            this.reportLog({
              eventId: "05_04_01_00",
              msg: event.detail
            });
          });
          element.on("error", async event => {
            // 打日志
            this.reportLog({
              eventId: "05_04_02_00",
              msg: event.detail
            });
          });

          element.on("error", event => {
            // toast错误
            Toast.fail(event);
          });
        } catch (error) {
          _this.loading = false;
        }
      };

      // 开始检查DOM并创建按钮
      checkDOMAndCreateButton();
    },
    /**
     * @method createGooglePayButton
     * @description google支付
     */
    createGooglePayButton() {
      const client_secret = this.paymentIntent.client_secret || "";
      const intent_id = this.paymentIntent.id || "";
      const customer_id = this.paymentIntent.customer_id || "";
      const countryCode = this.countryCode || "";
      // const currency = this.paymentIntent.currency || "";
      // const amount = this.paymentIntent.amount || "0.00";

      const _this = this;

      // 创建DOM检查和重试机制
      const checkDOMAndCreateButton = (retryCount = 0) => {
        const maxRetries = 10; // 最多重试10次
        const retryDelay = 100; // 每次重试间隔100ms

        // 检查 DOM 元素是否存在
        const targetElement = document.getElementById("googleOrApplePayButton");
        if (!targetElement) {
          if (retryCount < maxRetries) {
            console.log(
              `Google Pay: Target element not found, retrying in ${retryDelay}ms...`
            );
            setTimeout(() => {
              checkDOMAndCreateButton(retryCount + 1);
            }, retryDelay);
            return;
          } else {
            console.error(
              "Google Pay: Target element 'googleOrApplePayButton' not found after maximum retries"
            );
            _this.loading = false;
            return;
          }
        }
        try {
          const element = window.Airwallex.createElement("googlePayButton", {
            countryCode: countryCode,
            buttonType: "subscribe",
            customer_id: customer_id,
            intent_id: intent_id,
            client_secret: client_secret,
            mode: "recurring",
            amount: {
              //   value: amount,
              //   currency: currency,
            }
          });

          element.mount("googleOrApplePayButton");

          // element挂载完成
          element.on("ready", async () => {
            console.log("Google Pay ready====start");
            this.loading = false;
          });
          element.on("success", async event => {
            // 开启轮询
            // this.subscriptionQueryOrder();
            // 打日志
            this.reportLog({
              eventId: "05_04_01_00",
              msg: event.detail
            });
          });
          element.on("error", async event => {
            console.log(event, "Google Pay error");
            // 打日志
            this.reportLog({
              eventId: "05_04_02_00",
              msg: event.detail
            });
          });
        } catch (error) {
          console.error("Google Pay: Error creating element", error);
          _this.loading = false;
        }
      };

      // 开始检查DOM并创建按钮
      checkDOMAndCreateButton();
    }
  }
};
